import { Link } from 'react-router-dom';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';

const HomePage = () => {
  const services = [
    {
      icon: 'ri-hammer-line',
      title: 'General Building',
      description: 'Complete building works from extensions to structural alterations and new builds.',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Kitchen Refurbishment',
      description: 'Transform your kitchen with our complete design and installation service.',
    },
    {
      icon: 'ri-drop-line',
      title: 'Bathroom Refurbishment',
      description: 'Modern bathroom installations with quality fixtures and expert craftsmanship.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Plumbing',
      description: 'Professional plumbing services for installations, repairs and maintenance.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electrical',
      description: 'Certified electrical work including rewiring, installations and safety testing.',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Decorating & Maintenance',
      description: 'Interior and exterior decorating plus ongoing property maintenance services.',
    },
  ];

  const whyChooseUs = [
    {
      icon: 'ri-shield-check-line',
      title: 'Checkatrade Verified',
      description: 'Trusted and reviewed by homeowners across London',
    },
    {
      icon: 'ri-tools-fill',
      title: 'Comprehensive Services',
      description: 'All your property needs covered under one roof',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'London-Wide Coverage',
      description: 'Serving all London boroughs and surrounding areas',
    },
    {
      icon: 'ri-building-line',
      title: 'Part of Minuu Group',
      description: 'Backed by a trusted property services group',
    },
  ];

  const serviceAreas = [
    'Acton',
    'Ealing',
    'Chiswick',
    'Hammersmith',
    'Shepherd\'s Bush',
    'Fulham',
    'Kensington',
    'Chelsea',
    'Westminster',
    'Central London',
    'West London',
    'Surrounding Areas',
  ];

  return (
    <div className="min-h-screen bg-[#F5F3EF] overflow-x-hidden">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid lg:grid-cols-[60%_40%] gap-12 items-center">
            {/* Left Column */}
            <div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-black leading-tight mb-6 break-words">
                Professional Building &amp; Property Services Across London
              </h1>
              <p className="text-lg sm:text-xl text-gray-700 mb-8 leading-relaxed break-words">
                From complete refurbishments to routine maintenance, we deliver quality workmanship for homeowners, landlords and managing agents
              </p>
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 bg-black text-white px-6 sm:px-8 py-4 rounded-full text-sm sm:text-base font-medium hover:bg-gray-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Get Your Free Quote
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/services"
                  className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-gray-400 text-black px-6 sm:px-8 py-4 rounded-full text-sm sm:text-base font-medium hover:border-black transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  View Our Services
                </Link>
              </div>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
                <div className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-black text-xl"></i>
                  <span className="text-xs sm:text-sm font-medium text-gray-700 break-words">Checkatrade Registered</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-fill text-black text-xl"></i>
                  <span className="text-xs sm:text-sm font-medium text-gray-700 break-words">Fully Insured</span>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/053dc5c30e562e88425742afee926fae.jpg"
                alt="Modern kitchen refurbishment"
                className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview Grid */}
      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4 break-words">Our Services</h2>
            <p className="text-base sm:text-lg text-gray-600 break-words">Comprehensive property solutions for every need</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-5xl text-gray-700`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-black mb-3 break-words">{service.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-4 leading-relaxed break-words">{service.description}</p>
                <Link to="/services" className="inline-flex items-center gap-1 text-sm sm:text-base text-black font-medium hover:gap-2 transition-all cursor-pointer">
                  Learn more
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="py-20 px-6 lg:px-12 bg-[#F9F9F9]">
        <div className="max-w-[1000px] mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-black mb-6 break-words">
            Checkatrade Registered
          </h2>
          <p className="text-base sm:text-lg text-gray-700 mb-4 leading-relaxed max-w-[700px] mx-auto break-words">
            Minuu Property Services is a Checkatrade-registered company, committed to delivering reliable, high-quality building and property services.
          </p>
          <p className="text-base sm:text-lg text-gray-700 mb-8 leading-relaxed max-w-[700px] mx-auto break-words">
            Our Checkatrade profile provides customers with verified business details and reassurance when choosing a contractor.
          </p>
          <a
            href="https://www.checkatrade.com/trades/minuupropertyservices"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-black text-white px-6 sm:px-8 py-4 rounded-lg text-sm sm:text-base font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            View Our Checkatrade Profile
          </a>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 px-6 lg:px-12 bg-[#F5F3EF]">
        <div className="max-w-[1400px] mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-black text-center mb-12 break-words">
            Why Property Owners Trust Minuu
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyChooseUs.map((item, index) => (
              <div key={index} className="text-center">
                {item.title === 'Part of Minuu Group' ? (
                  <a 
                    href="https://www.minuucontractors.co.uk" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block cursor-pointer"
                  >
                    <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 p-3">
                      <img 
                        src="https://static.readdy.ai/image/6b8c7e9e23efe7296b6664942db70801/462da0711e6f27d5a46d94a9588244fb.png" 
                        alt="Minuu Contractors" 
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </a>
                ) : (
                  <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                    <i className={`${item.icon} text-5xl text-gray-700`}></i>
                  </div>
                )}
                <h3 className="text-lg sm:text-xl font-bold text-black mb-3 break-words">{item.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed break-words">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Areas Map Section */}
      <section className="py-20 px-6 lg:px-12 bg-white">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Side */}
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-black mb-6 break-words">
                Serving West &amp; Central London
              </h2>
              <p className="text-base sm:text-lg text-gray-700 mb-4 leading-relaxed break-words">
                We provide professional building and property services across West and Central London, focusing on areas where we can deliver an efficient and reliable service.
              </p>
              <p className="text-base sm:text-lg text-gray-700 mb-6 leading-relaxed break-words">
                For larger building or refurbishment projects, we are happy to consider work across wider London and surrounding areas, depending on scope and location.
              </p>
              <h3 className="text-lg sm:text-xl font-bold text-black mb-4 break-words">Primary Service Areas:</h3>
              <div className="grid grid-cols-2 gap-3 mb-8">
                {serviceAreas.map((area, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <i className="ri-map-pin-fill text-black"></i>
                    <span className="text-sm sm:text-base text-gray-700 break-words">{area}</span>
                  </div>
                ))}
              </div>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-black text-white px-4 sm:px-6 py-3 rounded-lg text-sm sm:text-base font-medium hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
              >
                Request a quote for your area
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            {/* Right Side - Map */}
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d158857.7281066494!2d-0.24168!3d51.52877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2s!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Service Areas Map"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Banner */}
      <section className="py-20 px-6 lg:px-12 bg-[#2B2B2B]">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 break-words">
            Ready to Start Your Project?
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 mb-8 break-words">
            Get a free, no-obligation quote today
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#F5F3EF] text-black px-8 sm:px-10 py-5 rounded-full text-base sm:text-lg font-semibold hover:bg-white transition-all whitespace-nowrap cursor-pointer"
          >
            Request Your Free Quote
            <i className="ri-arrow-right-line"></i>
          </Link>
          <div className="mt-8 flex items-center justify-center gap-2 text-white">
            <i className="ri-phone-fill text-xl sm:text-2xl"></i>
            <a href="tel:07773467507" className="text-xl sm:text-2xl font-bold hover:text-gray-300 transition-colors cursor-pointer break-all">
              07773 467507
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
